export function numberToShortVersion(
  value: number,
  singleDec?: boolean
): string {
  const absoluteValue = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (absoluteValue < 1_000) {
    return singleDec
      ? `${sign}${(Math.floor(absoluteValue * 100) / 100).toFixed(1)}`
      : `${sign}${Math.floor(absoluteValue * 100) / 100}`;
  }
  if (absoluteValue < 1_000_000) {
    return singleDec
      ? `${sign}${(Math.floor((absoluteValue / 1_000) * 100) / 100).toFixed(
          1
        )}K`
      : `${sign}${Math.floor((absoluteValue / 1_000) * 100) / 100}K`;
  }
  if (absoluteValue < 1_000_000_000) {
    return singleDec
      ? `${sign}${(Math.floor((absoluteValue / 1_000_000) * 100) / 100).toFixed(
          1
        )}M`
      : `${sign}${Math.floor((absoluteValue / 1_000_000) * 100) / 100}M`;
  }

  return singleDec
    ? `${sign}${(
        Math.floor((absoluteValue / 1_000_000_000) * 100) / 100
      ).toFixed(1)}B`
    : `${sign}${Math.floor((absoluteValue / 1_000_000_000) * 100) / 100}B`;
}

export function format2Dec(balance: number, divisor?: number): string {
  return balance == null
    ? "0"
    : (Math.round((balance / (divisor || 1)) * 1e2) / 1e2).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );
}

export function format3Dec(balance: number, divisor?: number): string {
  return balance == null
    ? "0"
    : (Math.round((balance / (divisor || 1)) * 1e3) / 1e3).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        }
      );
}

export function format4Dec(balance: number, divisor?: number): string {
  return balance == null
    ? "0"
    : (Math.round((balance / (divisor || 1)) * 1e4) / 1e4).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        }
      );
}

export function format5Dec(balance: number, divisor?: number): string {
  return balance === null
    ? "0"
    : (Math.round((balance / (divisor || 1)) * 1e5) / 1e5).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 5,
          maximumFractionDigits: 5,
        }
      );
}

export function format6Dec(balance: number, divisor?: number): string {
  return balance === null
    ? "0"
    : (Math.round((balance / (divisor || 1)) * 1e6) / 1e6).toLocaleString(
        "en-US"
      );
}

export function format9Dec(balance: number, divisor?: number): string {
  return balance == null
    ? "0"
    : (Math.round((balance / (divisor || 1)) * 1e9) / 1e9).toLocaleString(
        "en-US"
      );
}
